import {ICollectionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'
import {CollectionItemType} from '@toolify/server/src/models/mongoose/CollectionItemModel/enum/CollectionItemType'
import {CollectionItemBuiltInType} from '@toolify/server/src/models/mongoose/CollectionItemModel/enum/CollectionItemBuiltInType'
import {IResourceItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceItemResponseInstance'
import {i18n} from '@toolify/client/src/setup/i18n'
import {findCollectionResourceItem} from '@toolify/client/src/modules/collections/functions/findCollectionResourceItem'
import {getNamedOrFallback} from '@toolify/client/src/modules/collections/functions/getNamedOrFallback'

export function getCollectionItemLabel(
  item: ICollectionItemResponseInstance,
  resourceItems: IResourceItemResponseInstance[] = [],
): string {
  if(item.builtInType === CollectionItemBuiltInType.Favourites) {
    return i18n.global.t('collections.favourites')
  }
  if(item.builtInType === CollectionItemBuiltInType.Archive) {
    return i18n.global.t('collections.archive')
  }
  if(item.collectionItemType === CollectionItemType.Resource) {
    const resourceItem = findCollectionResourceItem(item, resourceItems)
    return getNamedOrFallback(resourceItem?.name || item.name, i18n.global.t('general.noName'))
  }
  if(item.collectionItemType === CollectionItemType.Link) {
    return getNamedOrFallback(item.name, i18n.global.t('collections.untitledLink'))
  }
  return getNamedOrFallback(item.name, i18n.global.t('collections.untitledFolder'))
}
